import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dropdown } from 'antd'
import * as Icons from '@ant-design/icons'

import { TransferItem } from './TransferItem'
import { CopyPasteItem } from './CopyPasteItem'
import { QcrItem } from './QcrItem'
import { Queries } from 'admin/lib/Api'
export function RecordDotMenuButton({ recordStatus, rawOrEnriched = false }) {
  const user = Queries.useUserSelf()
  const [allowedToRequeue, setAllowedToRequeue] = useState(false)

  // Hacky, but we need to open this dropdown menu so the shortcut keys are registered.
  // We then close it immediately after.
  useEffect(() => {
    document.getElementById('RecordDotMenuButton')?.click()
    setTimeout(() => {
      document.getElementById('RecordDotMenuButton')?.click()
    }, 1)
  }, [])

  useEffect(() => {
    if (
      user.data &&
      user.data.isSuper &&
      (recordStatus === 'New' || recordStatus === 'Failed')
    ) {
      setAllowedToRequeue(true)
    } else {
      setAllowedToRequeue(false)
    }
  }, [recordStatus, user.data])

  if (!user.data) {
    return ''
  }

  const menuItems = [
    {
      key: 'transferRecord',
      type: 'group',
      label: 'Transfer Record',
      children: [
        {
          key: 'moduleTransfer',
          icon: <Icons.RetweetOutlined />,
          label: <TransferItem recordStatus={recordStatus} type="module" />
        },
        {
          key: 'projectTransfer',
          icon: <Icons.RetweetOutlined />,
          label: <TransferItem recordStatus={recordStatus} type="project" />
        }
      ]
    },
    {
      key: 'copyPaste',
      type: 'group',
      label: 'Copy & Paste',
      children: [
        {
          key: 'copy',
          icon: <Icons.CopyOutlined />,
          label: <CopyPasteItem type="copy" rawOrEnriched={rawOrEnriched} />
        },
        {
          key: 'copyTopSectionOnly',
          icon: <Icons.CopyOutlined />,
          label: (
            <CopyPasteItem
              type="copyTopSectionOnly"
              rawOrEnriched={rawOrEnriched}
            />
          )
        },
        {
          key: 'paste',
          icon: <Icons.DiffOutlined />,
          label: <CopyPasteItem type="paste" />
        },
        {
          key: 'paste-all',
          icon: <Icons.SnippetsOutlined />,
          label: <CopyPasteItem type="paste-all" />
        }
      ]
    }
  ]

  if (allowedToRequeue) {
    menuItems.push({
      key: 'ocr',
      type: 'group',
      label: 'OCR',
      children: [
        {
          key: 'resendToQCR',
          icon: <Icons.RollbackOutlined />,
          label: <QcrItem />
        }
      ]
    })
  }

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger="click"
      placement="topRight"
      arrow
    >
      <Button
        id="RecordDotMenuButton"
        icon={<Icons.MoreOutlined rotate="90" />}
      />
    </Dropdown>
  )
}

RecordDotMenuButton.propTypes = {
  loaded: PropTypes.bool
}
